import classNames from "classnames";
import moment from "moment";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { garbageRecordSelectors } from "../../../../redux/app/garbage-record";
import {
	EGarbageRecordState,
	IGarbageAccidentalLoss,
	IGarbageDischargedIntoSea,
	IGarbageDischargedToReceptionAshoreOrOtherShips,
	IGarbageIncinerated,
} from "../../../../redux/app/garbage-record/@types";
import { IStore } from "../../../../redux/store";
import GarbageRecordEditsForPrint from "./Table/GarbageEditsForPrint";
import GRB1Participants from "./Table/GRB1Participants";
import { marpolSelectors } from "../../../../redux/app/marpol";
import GRB1Table from "./Table/GRB1Table";
import GRB1TableBody from "./Table/GRB1TableBody";

type OwnProps = {};
type GarbageRecordPrintViewProps = PropsFromRedux & OwnProps;
function GarbageRecordPrintView(props: GarbageRecordPrintViewProps) {
	const { historyList, isEPS } = props;

	return (
		<div className="py-6 ws-scroll">
			<div className="px-6 mb-12">
				<h1 className="mb-8 text-xl font-bold font-redhat-display">
					RECORD OF GARBAGE DISCHARGES
				</h1>
				<div className="mb-3">
					<h3 className="mb-1 text-base font-medium text-gray-700 ">
						Garbage Categories
					</h3>
					<div className="flex flex-row flex-wrap -mx-6">
						<ul className="px-6">
							<li className="my-3 text-gray-800 font-redhat-text">
								<span className="inline-block w-4 font-bold text-gray-700 font-redhat-text">
									A.
								</span>{" "}
								Plastics
							</li>
							<li className="my-3 text-gray-800 font-redhat-text">
								<span className="inline-block w-4 font-bold text-gray-700 font-redhat-text">
									B.
								</span>{" "}
								Food wastes
							</li>
							<li className="my-3 text-gray-800 font-redhat-text">
								<span className="inline-block w-4 font-bold text-gray-700 font-redhat-text">
									C.
								</span>{" "}
								Domestic wastes.
							</li>
						</ul>
						<ul className="px-6">
							<li className="my-3 text-gray-800 font-redhat-text">
								<span className="inline-block w-4 font-bold text-gray-700 font-redhat-text">
									D.
								</span>{" "}
								Cooking Oil
							</li>
							<li className="my-3 text-gray-800 font-redhat-text">
								<span className="inline-block w-4 font-bold text-gray-700 font-redhat-text">
									E.
								</span>{" "}
								Incinetor Ashes
							</li>
							<li className="my-3 text-gray-800 font-redhat-text">
								<span className="inline-block w-4 font-bold text-gray-700 font-redhat-text">
									F.
								</span>{" "}
								Operational wastes
							</li>
						</ul>
						<ul className="px-6">
							<li className="my-3 text-gray-800 font-redhat-text">
								<span className="inline-block w-4 font-bold text-gray-700 font-redhat-text">
									G.
								</span>{" "}
								Animal Carcass
							</li>
							<li className="my-3 text-gray-800 font-redhat-text">
								<span className="inline-block w-4 font-bold text-gray-700 font-redhat-text">
									H.
								</span>{" "}
								Fishing Gear
							</li>
							<li className="my-3 text-gray-800 font-redhat-text">
								<span className="inline-block w-4 font-bold text-gray-700 font-redhat-text">
									I.
								</span>{" "}
								E-Waste
							</li>
						</ul>
					</div>
				</div>
				<h1 className="w-3/4 font-medium leading-5 tracking-wide text-gray-600">
					Discharges under MARPOL Annex V regulations 4 (Discharge of garbage
					outside special areas), 5 (Special requirements for discharge of
					garbage from fixed or floating platform) or 6(Discharge of garbage
					withing special areas) or chapter 5 of part II-A of the Polar Code
				</h1>
			</div>
			<div className="px-6 mb-12 rounded-md">
				<GRB1Table>
					{historyList.map((grb1Record) => (
						<GRB1TableBody
							source="HISTORY"
							grb1Record={grb1Record}
							grb1Id={grb1Record.id}
							key={grb1Record.id}
						/>
					))}
				</GRB1Table>
			</div>
			<div className="px-6 mb-12 rounded-md"></div>
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const garbageRecordStore = garbageRecordSelectors._getStore(store);
	const marpolStore = marpolSelectors._getStore(store);
	const marpolReport = marpolSelectors.getMARPOLReport(marpolStore);
	const tenantName = marpolReport.MISC.tenantName;
	const isEPS = tenantName === "EPS";
	return {
		isEPS,
		historyList: garbageRecordSelectors.getHistoryList(garbageRecordStore),
	};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(GarbageRecordPrintView);
